import React from "react";
import PropTypes from "prop-types";
// Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import DividerIcon from "@mui/icons-material/ArrowForwardIos";
import makeStyles from "@mui/styles/makeStyles";
// Limitless imports
import { LoadingSpinner } from "@limitless/portal";

const useStyles = makeStyles(theme => ({
    container: {
        overflowY: "auto",
        overflowX: "auto",
        padding: disableTitle => (disableTitle ? 0 : 24),
        paddingBottom: 0,
        height: "calc(100vh - 88px)"
    },
    title: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
            cursor: "pointer"
        }
    },
    divider: {
        fontSize: "1rem",
        marginLeft: 8,
        marginRight: 8,
        marginTop: 2,
        color: theme.palette.primary.dark
    }
}));

const OnboardingContainer = ({ loading, children, subtitle, disableTitle = false }) => {
    const classes = useStyles(disableTitle);

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center">
                <LoadingSpinner size={30} color="primary" />
            </Grid>
        );
    }

    return (
        <div className={classes.container}>
            <Grid container direction="column">
                {!disableTitle && (
                    <Grid item>
                        <Grid container direction="row">
                            {subtitle && (
                                <>
                                    <DividerIcon className={classes.divider} />
                                    <Typography variant="subtitle1" color="textPrimary" style={{ fontWeight: 500 }}>
                                        {subtitle}
                                    </Typography>
                                </>
                            )}
                        </Grid>
                    </Grid>
                )}
                {children}
            </Grid>
        </div>
    );
};

export default OnboardingContainer;

OnboardingContainer.propTypes = {
    loading: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
    subtitle: PropTypes.string,
    disableTitle: PropTypes.bool
};
